import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	anonymous: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	anonymous: {
		id: 'issue-field-reporter-inline-edit-full.reporter.anonymous',
		defaultMessage: 'Anonymous',
		description: 'Text to display when no reporter has been specified.',
	},
});
export default messages;
